import { request } from "../api/api";
import { multipartRequest } from "../api/api";

export const login = (data) => {
  return request.post("/user/logIn/", data);
};
export const signup = (data) => {
  return multipartRequest.post("/user/createAccount/", data);
};
export const forgotPassword = (data) => {
  return request.post("/user/forgotPassword/", data);
};
export const updatePassword = (data) => {
  return request.post("/user/updatePassword/", data);
};
export const changePassword = (id, data) => {
  return request.put(`/user/changePassword/${id}/`, data);
};
export const logout = (token) => {
  return request.post("/user/logOut/", token);
};
export const userPropfile = (id) => {
  return request.get(`/user/getUserProfileData/${id}`);
};
export const updateUserProfile = (id, data) => {

  return multipartRequest.put(`/user/updateUserProfile/${id}/`, data)
};
export const loginWithGoggle = (data) => {
  return request.post("/user/registerWithSocialMedia/", data)
};

/*************************Admin dashboard***********************/

export const getDataCollectorList = ({data, currentPage, perPage } = {}) => {
  let queryParams = [];

  queryParams.push(`ordering=-id`);
  if (currentPage && perPage) {
    if (currentPage) queryParams.push(`page=${currentPage}`);
    if (perPage) queryParams.push(`page_size=${perPage}`);
  }
  if (data?.search) queryParams.push(`search=${data.search}`);
  let queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  return request.get(`/admin_panel/getDataCollectorList/${queryString}`);
};
export const getDataCollectorListDetails = (id) => {
  return request.get(`/admin_panel/getDataCollectorList/${id}`);
};
export const deactivateDataCollectorList = (id, data) => {
  return request.put(`admin_panel/updateUserState/${id}/`, data)
};
export const getRegionList = (searchParams, params) => {
  let queryParams = [];
  // Add search only if it exists
  if (searchParams?.search) {
    queryParams.push(`search=${searchParams.search}`);
  }
  if (params?.page && params?.per_page) {
    queryParams.push(`page=${params.page}`);
    queryParams.push(`page_size=${params.per_page}`);
  }
  let queryString = `?${queryParams.join("&")}`;

  return request.get(`/admin_panel/region/${queryString}`);
};
export const addRegionList = (data) => {
  return request.post(`/admin_panel/region/`, data)
};
export const updateRegionList = (id, data) => {
  return request.put(`/admin_panel/region/${id}/`, data)
};
export const deleteRegionList = (id) => {
  return request.delete(`/admin_panel/region/${id}/`)
};
export const getStateList = (searchParams, params) => {
  let queryParams = [];
  // Add search only if it exists
  if (searchParams?.search) {
    queryParams.push(`search=${searchParams.search}`);
  }
  if (params?.page, params?.per_page) {
    queryParams.push(`page=${params.page}`);
    queryParams.push(`page_size=${params.per_page}`);
  }

  let queryString = `?${queryParams.join("&")}`;

  return request.get(`/admin_panel/state/${queryString}`);
};
export const getStateDetails = (id) => {
  return request.get(`/admin_panel/state/?region_id=${id}`);
};
export const addStateList = (data) => {
  return request.post(`/admin_panel/state/`, data)
};
export const updateStateList = (id, data) => {
  return request.put(`/admin_panel/state/${id}/`, data)
};
export const deleteStateList = (id) => {
  return request.delete(`/admin_panel/state/${id}/`)
};
export const getLocalGovernmentList = (searchParams, localGovCurrentPage, perPage) => {
  let queryParams = [];
  // Add search only if it exists
  if (searchParams?.search) {
    queryParams.push(`search=${searchParams.search}`);
  }

  if (localGovCurrentPage && perPage) {
    queryParams.push(`page=${localGovCurrentPage}`);
    queryParams.push(`page_size=${perPage}`);
  }
  let queryString = `?${queryParams.join("&")}`;

  return request.get(`/admin_panel/localGovernment/${queryString}`);
};
export const getLocalGovernmentDetails = (data) => {
  return request.get(`/admin_panel/localGovernment/?region_id=${data.region_id}&state_id=${data.state_id}`);
};
export const addLocalGovernmentList = (data) => {
  return request.post(`/admin_panel/localGovernment/`, data)
};
export const updateLocalGovernmentList = (id, data) => {
  return request.put(`/admin_panel/localGovernment/${id}/`, data)
};
export const deleteLocalGovernmentList = (id) => {
  return request.delete(`/admin_panel/localGovernment/${id}/`)
};
export const getTaskAssignment = (data, currentPage, perPage) => {
  // Construct query parameters dynamically
  const queryParams = new URLSearchParams();

  if (data.data_collector__id) queryParams.append("data_collector__id", data.data_collector__id);
  if (data.status) queryParams.append("status", data.status);
  if (data.start_datetime) queryParams.append("start_datetime", data.start_datetime);
  if (data.end_datetime) queryParams.append("end_datetime", data.end_datetime);
  if (data.search) queryParams.append("search", data.search);

  // Pagination parameters
  queryParams.append("page", currentPage);
  queryParams.append("per_page", perPage);

  // Make request with constructed query string
  return request.get(`/admin_panel/assignTaskToCollector?${queryParams.toString()}`);
};
export const addTaskAssignment = (data) => {
  return request.post(`/admin_panel/assignTaskToCollector/`, data);
};
export const updateTaskAssignment = (id, data) => {
  return request.put(`/app/assignTaskToCollectorForApp/${id}/`, data)
};
export const getTaskAssignmentDetails = (id) => {
  return request.get(`/admin_panel/assignTaskToCollector/${id}/`)
};
export const sendReminder = (data) => {
  return request.post(`/admin_panel/sendReminder/`, data)
};
export const getTaskSubmitReport = (data, currentPage, perPage) => {
  let queryParams = [];
  // Add assign_task_id if it exists in data
  if (data.assign_task_id) {
    queryParams.push(`assign_task_id=${data.assign_task_id}`);
  }
  if (data.currentPage) queryParams.push(`page=${currentPage}`);
  if (data.perPage) queryParams.push(`page_size=${perPage}`);
  let queryString = `?${queryParams.join("&")}`;

  return request.get(`/app/submitAssignTaskReport/${queryString}`, data)
};

export const getFarmingMethodOptions = () => {
  return request.get("/app/getFarmingMethod/")
}
export const getFarmerListExcel = () => {
  return request.get(`/superadmin_panel/getFarmerListExcel/`)
}
export const getFarmersList = (data, currentPage, perPage) => {
  let queryParams = new URLSearchParams();
  // Add search only if it exists
  if (data.search) queryParams.append("search", data.search);
  if (data.status) queryParams.append("status", data.status);
  if (data.start_date) queryParams.append("start_datetime", data.start_date);
  if (data.end_date) queryParams.append("end_datetime", data.end_date);
  if (data.gender) queryParams.append("gender", data.gender);
  if (data.region_name) queryParams.append("region__region_name", data.region_name);
  if (data.state_name) queryParams.append("state__state_name", data.state_name);
  if (data.local_government_name) queryParams.append("local_government__local_government_name", data.local_government_name);
  if (data.farming_method_name) queryParams.append("farming_method__name", data.farming_method_name);
  if (data.count) queryParams.append("count", data.count);
  if (data.within_the_last) queryParams.append("within_the_last", data.within_the_last);
  if (data.more_than) queryParams.append("more_than", data.more_than);

  // Pagination parameters
  queryParams.append("page", currentPage);
  queryParams.append("per_page", perPage);

  return request.get(`/admin_panel/getFarmerList/?${queryParams.toString()}`);
};
export const getFarmerDetails = (id) => {
  return request.get(`/app/getFarmerDetails/?&farmer_id=${id}`);
};
export const updateFarmerStatus = (data) => {
  return request.post(`/admin_panel/updateFarmerStatus/`, data)
};

export const getReportList = (data, currentPage, perPage) => {
  let queryParams = new URLSearchParams();
  // Add search only if it exists
  if (data.search) queryParams.append("search", data.search);

  // Pagination parameters
  queryParams.append("page", currentPage);
  queryParams.append("per_page", perPage);

  return request.get(`/admin_panel/getReport/?${queryParams.toString()}`);
}

export const getReportDetails = (id) => {
  return request.get(`/admin_panel/getReport/${id}/`)
};

export const getFarmerListForReport = (data, currentPage, perPage) => {
  let queryParams = new URLSearchParams();
  if (data.report_id) queryParams.append("report_id", data.report_id);
  if (currentPage) queryParams.append("page", currentPage);
  if (perPage) queryParams.append("per_page", perPage);
return request.get(`/admin_panel/getFarmerListForReport/?${queryParams.toString()}`, data);
};
/*************************Super admin dashboard***********************/

export const getTypeOfCrops = () => {
  return request.get("/superadmin_panel/getTypeOfCrops/");
};
export const crops = (id, page) => {
  return request.get(`/superadmin_panel/crops/?crops_type_id=${id}&page=${page}&page_size=${10}`);
};
export const addCrops = (params) => {
  return request.post("/superadmin_panel/crops/", params);
};
export const editCrops = (params, id) => {
  return request.put(`/superadmin_panel/crops/${id}/`, params);
};
export const deleteCrops = (id) => {
  return request.delete(`/superadmin_panel/crops/${id}/`);
};
export const getTypeOfLivestocks = () => {
  return request.get("/superadmin_panel/getTypeOfLivestock/");
};
export const livestocks = (id, page) => {
  return request.get(`/superadmin_panel/livestock/?livestock_type_id=${id}&page=${page}&page_size=${10}`);
};
export const addLiveStocks = (params) => {
  return request.post("/superadmin_panel/livestock/", params);
};
export const editLivestock = (params, id) => {
  return request.put(`/superadmin_panel/livestock/${id}/`, params);
};
export const deleteLivestock = (id) => {
  return request.delete(`/superadmin_panel/livestock/${id}/`);
};
export const getTypeOfPisciculture = () => {
  return request.get("/superadmin_panel/getTypeOfPisciculture/");
};
export const pisciculture = (id, page) => {
  return request.get(`/superadmin_panel/pisciculture/?pisciculture_type_id=${id}&page=${page}&page_size=${10}`);
};
export const addPisciculture = (params) => {
  return request.post("/superadmin_panel/pisciculture/", params);
};
export const editPisciculture = (params, id) => {
  return request.put(`/superadmin_panel/pisciculture/${id}/`, params);
};
export const deletePisciculture = (id) => {
  return request.delete(`/superadmin_panel/pisciculture/${id}/`);
};
export const getTypeOfTrainingProgram = () => {
  return request.get("/superadmin_panel/getTypeOfTrainingProgram/");
};
export const trainingProgram = (id, page) => {
  return request.get(`/superadmin_panel/trainingProgram/?training_program_type_id=${id}&page=${page}&page_size=${10}`);
};
export const addTrainingProgram = (params) => {
  return request.post("/superadmin_panel/trainingProgram/", params);
};
export const editTrainingProgram = (params, id) => {
  return request.put(`/superadmin_panel/trainingProgram/${id}/`, params);
};
export const deleteTrainingProgram = (id) => {
  return request.delete(`/superadmin_panel/trainingProgram/${id}/`);
};
export const trainingProgramSponsor = (page) => {
  return request.get(`/superadmin_panel/trainingProgramSponsor/?page=${page}&page_size=${10}`);
};
export const addTrainingProgramSponsor = (params) => {
  return request.post("/superadmin_panel/trainingProgramSponsor/", params);
};
export const editTrainingProgramSponsor = (params, id) => {
  return request.put(`/superadmin_panel/trainingProgramSponsor/${id}/`, params);
};
export const deleteTrainingProgramSponsor = (id) => {
  return request.delete(`/superadmin_panel/trainingProgramSponsor/${id}/`);
};
export const certificationAndTraining = (page) => {
  return request.get(`/superadmin_panel/certificationAndTraining/?page=${page}&page_size=${10}`);
};
export const addCertificationAndTraining = (params) => {
  return request.post("/superadmin_panel/certificationAndTraining/", params);
};
export const editCertificationAndTraining = (params, id) => {
  return request.put(`/superadmin_panel/certificationAndTraining/${id}/`, params);
};
export const deleteCertificationAndTraining = (id) => {
  return request.delete(`/superadmin_panel/certificationAndTraining/${id}/`);
};
export const getTypeOfMachinery = () => {
  return request.get("/superadmin_panel/getTypeOfMachinery/");
};
export const machinery = (id, page) => {
  return request.get(`/superadmin_panel/getTypeOfMachineryEquipment/?machinery_type_id=${id}&page=${page}&page_size=${10}`);
};
export const addMachineryEquipment = (params) => {
  return request.post("/superadmin_panel/getTypeOfMachineryEquipment/", params);
};
export const editMachineryEquipment = (params, id) => {
  return request.put(`/superadmin_panel/getTypeOfMachineryEquipment/${id}/`, params);
};
export const deleteMachineryEquipment = (id) => {
  return request.delete(`/superadmin_panel/getTypeOfMachineryEquipment/${id}/`);
};

/*************************Role management***********************/

export const getRoleList = (data, currentPage, perPage, role_id) => {
  let queryParams = [];
  if (data?.search) queryParams.push(`search=${data.search}`)
  if (currentPage) queryParams.push(`page=${currentPage}`);
  if (perPage) queryParams.push(`page_size=${perPage}`);
  if (role_id) queryParams.push(`role_id=${role_id}`);
  let queryString = `${queryParams.join("&")}`;

  return request.get(`/superadmin_panel/getUserRole/?${queryString}`);
}

export const addRole = (params) => {
  return request.post("/superadmin_panel/addUserRole/", params);
}

export const editRole = (params, id) => {
  return request.put(`/superadmin_panel/updateUserRole/${id}/`, params);
}

export const deleteRole = (params) => {
  return request.post(`/superadmin_panel/deleteUserRole/`, params);
}
export const gerModuleList = () => {
  return request.get("/superadmin_panel/getModuleData/");
}
/*************************Dashboard***********************/

export const getDashboardGraphData = (data) => {
  return request.post("/superadmin_panel/getDataCollectorPerformanceData/", data);
};

export const getDashboardCount = (data) => {
  return request.get("/superadmin_panel/getWebDashboardCount/", data);
}

/*************************Bulk Delete***********************/

export const regionBulkDelete = (data) => {
  return request.post("/admin_panel/region/bulk_delete/", data);
}

export const stateBulkDelete = (data) => {
  return request.post("/admin_panel/state/bulk_delete/", data);
}

export const localgovBulkDelete = (data) => {
  return request.post("/admin_panel/localGovernment/bulk_delete/", data);
}

export const cropsBulkDelete = (data) => {
  return request.post("/superadmin_panel/crops/bulk_delete/", data);
}

export const macineryBulkDelete = (data) => {
  return request.post("/superadmin_panel/getTypeOfMachineryEquipment/bulk_delete/", data);
}

export const piscicultureBulkDelete = (data) => {
  return request.post("/superadmin_panel/pisciculture/bulk_delete/", data);
}

export const livestockBulkDelete = (data) => {
  return request.post("superadmin_panel/livestock/bulk_delete/", data);
}


/*************************User Management***********************/
export const getUser = (data, currentPage, perPage) => {
  if (data.search) {
    return request.get(`/user/getUsers/?search=${data.search}&page=${currentPage}&page_size=${perPage}`);
  }
  return request.get(`/user/getUsers/?page=${currentPage}&page_size=${perPage}`);
};
export const getUserId = (id) => {
  return request.get(`/user/getUsers/${id}/`);
};

export const updateAdminStatus = (data) => {
  return request.post("/superadmin_panel/updateAdminStatus/", data);
}

/*************************Demo File***********************/
export const getRegionLocalityDemoFile = (data) => {
  return request.post("/superadmin_panel/getRegionLocalityExcel/", (data))
}

export const getTypeOfCropsExcel = (data) => {
  return request.post("/superadmin_panel/getTypeOfCropsExcel/", (data))
}

export const getTypeOfLivestockExcel = (data) => {
  return request.post("/superadmin_panel/getTypeOfLivestockExcel/", (data))
}

export const getTypeOfPiscicultureExcel = (data) => {
  return request.post("/superadmin_panel/getTypeOfPiscicultureExcel/", (data))
}

export const getTypeOfMachineryExcel = (data) => {
  return request.post("/superadmin_panel/getTypeOfMachineryExcel/", (data))
}

export const certificationsTrainingExcel = () => {
  return request.post("/superadmin_panel/certificationsTrainingExcel/")
}

export const trainingProgramExcel = (data) => {
  return request.post("/superadmin_panel/trainingProgramExcel/", (data))
}

export const whoSponsoredExcel = () => {
  return request.post("/superadmin_panel/whoSponsoredExcel/")
}

/********************** Import excel file **********************/
export const importRegionExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importRegionExcel/", (data))
}
export const importStateExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importStateExcel/", (data))
}
export const importLocalGovernmentExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importLocalGovernmentExcel/", (data))
}
export const importTypeOfCropsExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importTypeOfCropsExcel/", (data))
}
export const importTypeOfLivestockExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importTypeOfLivestockExcel/", (data))
}
export const importTypeOfPiscicultureExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importTypeOfPiscicultureExcel/", (data))
}
export const importTypeOfMachineryExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importTypeOfMachineryExcel/", (data))
}
export const importCertificationAndTrainingExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importCertificationAndTrainingExcel/", (data))
}
export const importTrainingProgramsExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importTrainingProgramExcel/", (data))
}
export const importWhoSponsoredExcel = (data) => {
  return multipartRequest.post("/superadmin_panel/importWhoSponsoredExcel/", (data))
}